import clsx from "clsx";
import type { ReactNode } from "react";
import { ProjectOverviewButton } from "@/components/ProjectOverviewButton";
import { useProjectOverview } from "@/projectOverview/useProjectOverview";

export function ProjectOverviewLink({
  auftragId,
  label,
  className,
  labelClassName,
  showButton = true,
  disabled,
}: {
  auftragId: number | null | undefined;
  label: ReactNode;
  className?: string;
  labelClassName?: string;
  showButton?: boolean;
  disabled?: boolean;
}) {
  const { open } = useProjectOverview();
  const id = Number(auftragId);
  const canOpen = Number.isFinite(id) && id > 0 && !disabled;

  if (!canOpen) {
    return <span className={className}>{label}</span>;
  }

  return (
    <span className={clsx("inline-flex min-w-0 items-center gap-1.5", className)}>
      <button
        type="button"
        className={clsx(
          "min-w-0 text-left hover:underline",
          labelClassName ?? "font-medium text-tint",
        )}
        title="Projektübersicht öffnen"
        onClick={(e) => {
          e.stopPropagation();
          open(id);
        }}
      >
        {label}
      </button>
      {showButton ? (
        <ProjectOverviewButton auftragId={id} className="h-7 w-7 shrink-0" />
      ) : null}
    </span>
  );
}
